<mat-form-field class="mat-select-sm" appearance="fill">
    <mat-select [(ngModel)]="selectedStatus" (ngModelChange)="valueChanged()">
        <mat-option class="mat-option-sm" selected value="All">All</mat-option>
        <mat-option *ngFor="let option of options | async" [value]="option.Name">
          {{option.Name}}
        </mat-option>
    </mat-select>
  </mat-form-field>
  